import type { SelectedEmailAsset } from "src/components/llm/component-picker";
import type { StyleSelection } from "src/pages/ad-studio/components/ad-studio-style-select";

/** Every pick in the composer. */
export type ComposerSelections = {
  adsStyle: StyleSelection;
  emailStyle: StyleSelection;
  creativeBoost: boolean;
  useVideoEngine: boolean;
  adTemplateIds: string[];
  adTemplateFolderIds: string[];
  adTemplateFolderBrandProfileId?: string;
  emailTemplates: SelectedEmailAsset[];
  emailComponents: SelectedEmailAsset[];
  skillIds: string[];
};

export const DEFAULT_SELECTIONS: ComposerSelections = {
  adsStyle: { kind: "auto" },
  emailStyle: { kind: "auto" },
  creativeBoost: false,
  useVideoEngine: false,
  adTemplateIds: [],
  adTemplateFolderIds: [],
  adTemplateFolderBrandProfileId: undefined,
  emailTemplates: [],
  emailComponents: [],
  skillIds: [],
};

/** The picks that go with one message; the rest hold across messages and come back when a chat reopens. */
export const CLEARED_ON_SEND = [
  "adTemplateIds",
  "adTemplateFolderIds",
  "adTemplateFolderBrandProfileId",
  "emailTemplates",
  "emailComponents",
  "skillIds",
] as const satisfies readonly (keyof ComposerSelections)[];

/** The selections once a message is sent. */
export function clearSentSelections(
  selections: ComposerSelections,
): ComposerSelections {
  return {
    ...selections,
    ...Object.fromEntries(
      CLEARED_ON_SEND.map((key) => [key, DEFAULT_SELECTIONS[key]]),
    ),
  };
}
